class CollectionCategories {
  constructor() {
    this.init();
  }

  init() {
    this.categoryButtons = document.querySelectorAll('.category-item');
    this.productPanels = document.querySelectorAll('.products-panel');
    this.defaultPanel = document.querySelector('.default-collection-panel');
    
    // Remove any active states initially
    this.categoryButtons.forEach(button => {
      button.classList.remove('active');
    });
    
    this.productPanels.forEach(panel => {
      panel.classList.remove('active');
    });
    
    // Show default panel initially
    if (this.defaultPanel) {
      this.defaultPanel.classList.add('active');
    }
    
    this.bindEvents();
  }

  bindEvents() {
    this.categoryButtons.forEach(button => {
      button.addEventListener('click', () => this.switchCategory(button));
    });
  }

  switchCategory(selectedButton) {
    // Update active button
    this.categoryButtons.forEach(button => {
      button.classList.remove('active');
    });
    selectedButton.classList.add('active');
    let selectedButtonImage = selectedButton.querySelector(".category-image img");
    let selectedBreadcrumbSource = selectedButton.querySelector('.category-title').textContent;
    // Hide default panel if it exists
    if (this.defaultPanel) {
      this.defaultPanel.classList.remove('active');
    }
    if (selectedButtonImage) {
      selectedButtonImage.dataset.breadcrumbSource = selectedBreadcrumbSource;
    }
    // Update active panel
    const targetPanel = document.querySelector(`[data-category-panel="${selectedButton.dataset.category}"]`);
    this.productPanels.forEach(panel => {
      panel.classList.remove('active');
    });
    targetPanel.classList.add('active');
    targetPanel.querySelectorAll('.collection-categories-prod-card').forEach((image)=>{
      image.dataset.breadcrumbSource = selectedBreadcrumbSource;
    })
    // Reinitialize the Splide carousel in the new panel
    const carousel = targetPanel.querySelector('.splide');
    if (carousel) {
      const splideInstance = carousel.splide;
      if (splideInstance) {
        splideInstance.refresh();
      }
    }

    this.scrollToSection()
  }

  scrollToSection() {
    const element = document.querySelector('.collection-categories-section');
    if (element) {
        const elementRect = element.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.scrollY;
        const middle = absoluteElementTop + elementRect.height;
        const targetScrollPosition = middle - window.innerHeight;
        
        window.scrollTo({
            top: targetScrollPosition,
            behavior: 'smooth'
        });
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CollectionCategories();
  });
} else {
  new CollectionCategories();
}